import React from 'react';
import PropTypes from 'prop-types';
import SelectiveQuestionResults from './SelectiveQuestionResults';
import NumericQuestionResults from './NumericQuestionResults';
import OrderedQuestionResults from './OrderedQuestionResults';
import ImageQuestionResults from './ImageQuestionResults';
import MatrixQuestionResults from './MatrixQuestionResults';
import OpenBudgetQuestionResults from './OpenBudgetQuestionResults';
import BasicQuestionResults from './BasicQuestionResults';
import GeolocationQuestionResults from './GeolocationQuestionResults';
import MapDrawLineQuestionResults from './MapDrawLineQuestionResults';
import MapDrawShapeQuestionResults from './MapDrawShapeQuestionResults';
import MediaUploadQuestionResults from './MediaUploadQuestionResults';

function QuestionResults(props) {
  const { question, engagementSummary, createdAt } = props;
  const hasResponses = Boolean(engagementSummary.responseCount);

  switch (question.displayType) {
    case 'basic':
      return (
        <BasicQuestionResults
          question={question}
          hasResponses={hasResponses}
          engagementSummary={engagementSummary}
          createdAt={createdAt}
        />
      );
    case 'single_select':
    case 'multi_select':
    case 'dropdown':
    case 'rating':
    case 'budget':
      return <SelectiveQuestionResults question={question} hasResponses={hasResponses} />;
    case 'numeric':
    case 'slider':
      return <NumericQuestionResults question={question} hasResponses={hasResponses} />;
    case 'geolocation':
      return <GeolocationQuestionResults question={question} hasResponses={hasResponses} />;
    case 'image':
      return <ImageQuestionResults question={question} hasResponses={hasResponses} />;
    case 'map_draw_line':
      return <MapDrawLineQuestionResults question={question} hasResponses={hasResponses} />;
    case 'map_draw_shape':
      return <MapDrawShapeQuestionResults question={question} hasResponses={hasResponses} />;
    case 'media_upload':
      return <MediaUploadQuestionResults question={question} hasResponses={hasResponses} />;
    case 'ordered':
      return <OrderedQuestionResults question={question} hasResponses={hasResponses} />;
    case 'matrix':
      return <MatrixQuestionResults question={question} hasResponses={hasResponses} />;
    case 'budget_open':
      return <OpenBudgetQuestionResults question={question} hasResponses={hasResponses} />;
    default:
      return null;
  }
}

QuestionResults.propTypes = {
  question: PropTypes.shape({
    displayType: PropTypes.string.isRequired,
  }).isRequired,
  engagementSummary: PropTypes.shape({
    responseCount: PropTypes.number.isRequired,
    endTime: PropTypes.string,
  }).isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default QuestionResults;
